<script lang="ts">
	// shadcn-svelte Dialog.Description (bits-ui), RESTYLED. NO arbitrary `[..]` values.
	import { Dialog as DialogPrimitive } from "bits-ui";
	import { cn } from "../../../utils.js";

	let {
		ref = $bindable(null),
		class: className,
		...restProps
	}: DialogPrimitive.DescriptionProps = $props();
</script>

<DialogPrimitive.Description
	bind:ref
	data-slot="dialog-description"
	class={cn("text-sm leading-relaxed text-muted", className)}
	{...restProps}
/>
